import { AbstractPmsApiService } from "./abstract.service";
import {StaahRoomTypeModel} from "../models/staah-room-type.model";

/**
 * @class StaahRoomTypeService
 * @abstract
 * @extends {AbstractPmsApiService<StaahRoomTypeService>}
 */
export class StaahRoomTypeService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/staah-room-types';
    }

    newModel(attributes) {

        return new StaahRoomTypeModel(attributes);
    }

     /**
     * @returns {Promise.<StaahRoomTypeModel>}
     */
    get() {
        return this.http
            .get(this.url(), {
                headers: this.authHeaders
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/staah-room-type.service.js